<template>
  <div v-if="page">
    <vue-title
      title="Seasons - Whoosh! Your Indoor Cycling Solution"
    ></vue-title>

    <section class="seasons-main seasons-page-wrap clearfix">
      <div class="container">
        <div class="row">
          <section class="col-md-12">
            <SeasonList
              :seasons="seasons"
              :loading="loading"
              :pagination="pagination"
              @page-changed="handlePageChange"
            />
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SeasonList from "@/components/season/SeasonList";

export default {
  name: "Seasons",

  components: {
    SeasonList,
  },

  computed: {
    ...mapGetters("season", ["seasons", "loading", "pagination"]),
    ...mapGetters("page", ["page"]),
  },

  mounted() {
    document.body.classList.add("seasons-page");
    this.loadSeasons();
  },

  destroyed() {
    document.body.classList.remove("seasons-page");
  },

  methods: {
    loadSeasons(page = 1) {
      this.$store.dispatch("season/fetchSeasons", { page, limit: 15 });
    },

    handlePageChange(page) {
      this.loadSeasons(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.seasons-page-wrap {
  padding: 40px 0;
}
</style>
